import { Component } from '@angular/core';
import { ITableColumnConfig, ITableHeaderConfig } from 'src/app/components/tablecomponent/tablecomponent.constants';
import { CadloadcellComponent } from 'src/app/modals/cadloadcell/cadloadcell.component';
import { LoadCellModel } from 'src/app/models/loadcellmodel';
import { ModalService } from 'src/app/services/modalservice/modalservice.service';
import { LoadCellsRepository } from 'src/app/services/repository/loadcell.repository';
import { ArrayInterfaceToArrayClass } from 'src/app/services/uteis/arraytoarrayclass';

@Component({
  selector: 'app-loadcells',
  templateUrl: './loadcells.component.html',
  styleUrls: ['./loadcells.component.scss']
})
export class LoadcellsComponent {
  public loading: boolean = false;
  public list: LoadCellModel[] = [];

  /**
   * Configurações de table
   */
  public configTable: ITableColumnConfig[] = [
    {
      key: 'idCelulaCarga',
      label: 'ID',
      size: '100px',
      columnsize: 7.5,
      alignment: 'center',
    },
    {
      key: 'idMaquina',
      label: 'ID Máquina',
      size: '100px',
      columnsize: 7.5,
      alignment: 'center',
    },
    { key: 'Marca', label: 'Marca', size: '1fr', columnsize: 40 },
    { key: 'Modelo', label: 'Modelo', size: '1fr', columnsize: 40 },
    { key: 'NumeroSerial', label: 'Serial', size: '1fr', columnsize: 40 },
    { key: 'EnderecoModbus', label: 'Endereço ModBus', size: '1fr', columnsize: 40 },
  ];

  public TableHeaderConfig: ITableHeaderConfig = {
    background: 'var(--color-toptable)',
    color: 'var(--color-toptable-contrast)',
  };

  constructor(private repository: LoadCellsRepository, private modal: ModalService) {}

  ngOnInit(): void {
    this.init();
  }

  public async init() {
    this.loading = true;
    try {
      this.list = ArrayInterfaceToArrayClass(
        await this.repository.getAll(),
        LoadCellModel
      );
      console.log('[INFO] Listagem de Células de Carga => ', this.list);
    } catch (error) {
      console.log('[ERROR] Init => ', error);
    }
    this.loading = false;
  }

  public async new(data: LoadCellModel = new LoadCellModel()) {
    try {
      this.modal
        .show(CadloadcellComponent, {
          height: 'auto',
          width: '566px',
          data: data,
        })
        .then((_) => {
          this.init();
        });
    } catch (error) {}
  }
}
